/**
 * Component for ArtistEventsRowItem
 *
 * @module components/ArtistEventsRowItem
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonT3 from '../../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../../components/lib/ButtonT3/constants';
import { messages as m } from '../../../constants/ArtistEvents';
import RowItem from '../RowItem/RowItem';

import './ArtistEventRowItem.scss';

export class ArtistEventRowItem extends React.Component {
  static propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    mainText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    secondText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onButtonClick: PropTypes.func,
    noBorder: PropTypes.bool,
    useDarkTheme: PropTypes.bool,
    useLightTheme: PropTypes.bool,
    buttonT3TextColor: PropTypes.string,
    isRowSmall: PropTypes.bool,
  };

  render() {
    const { useDarkTheme, useLightTheme } = this.props;
    const buttonT3Theme = useDarkTheme
      ? ButtonT3Theme.WHITE
      : useLightTheme
      ? ButtonT3Theme.BLACK
      : null;
    return (
      <RowItem
        date={this.props.date}
        mainText={this.props.mainText}
        secondText={this.props.secondText}
        isRowSmall={this.props.isRowSmall}
        isRightColPersistent={true}
        hasBorderTopBottom={true}
        noHover={true}
        noBorder={this.props.noBorder}
        rightColChild={
          <ButtonT3
            size={ButtonT3Size.LARGE}
            theme={buttonT3Theme}
            isHoverShaded={useLightTheme}
            onClick={this.props.onButtonClick}
            textColor={this.props.buttonT3TextColor}
          >
            <FormattedMessage {...m.getTickets} />
          </ButtonT3>
        }
        useDarkTheme={this.props.useDarkTheme}
        useLightTheme={this.props.useLightTheme}
      />
    );
  }
}

export default ArtistEventRowItem;
